import toast from "react-hot-toast";
import { log, supabase } from ".";

export const getClientes = async ({ pais, orderBy = "nombre", ascending = true }) => {
  try {
    const data = await supabase.select("clientes", {
      filters: { pais },
      orderBy,
      ascending,
    });

    // Filtrar clientes marcados como eliminados (soft delete)
    const activos = data?.filter((c) => !c.eliminada) || [];

    if (activos.length === 0) {
      toast.error("No hay clientes cargados en la base de datos");
      throw new Error("No data found");
    }

    return activos;
  } catch (error) {
    log.error("getClientes", error);
    throw error;
  }
};
